import NotificationItem from "./item/NotificationItem";
import {Notification} from "../../utils/models/Notification";
import {useRef} from "react";
import {FixedSizeList, ListChildComponentProps} from "react-window";

interface Props {
    notifications: Notification[];
    width: number;
    height: number;
}

export default function NotificationList({width, height, notifications}: Props) {
    const listRef = useRef<any>();

    const Row = ({index, style, data}: ListChildComponentProps) => {
        return (
            <NotificationItem
                key={index}
                notification={notifications[index]}
                index={index}
                length={notifications.length}
                style={style}
            />
        );
    };

    return (
        <FixedSizeList
            className="List"
            height={height}
            itemCount={notifications.length}
            itemSize={100}
            width={width}
            ref={listRef}
        >
            {Row}
        </FixedSizeList>
    )
}